import key from 'music-key';
const noteOrder = 'C D E F G A B'.split(' ');

export default function getScaleNotes(userKey, range) {
  range = range || [3, 4];

  const scale = key.scale(userKey);
  const startingIndex = noteOrder.indexOf(scale[0][0])

  return range.reduce( (allNotes, r) => {
    return allNotes.concat(scale.map( n => {
      const newIndex = noteOrder.indexOf(n[0]);
      let octave = r;

      if (newIndex < startingIndex) {
        octave++;
      }

      return n + octave;
    }))
  }, []);
}



// WEBPACK FOOTER //
// ./src/get-scale-notes.js